import { render, staticRenderFns } from "./expandTicket.vue?vue&type=template&id=a38279c6&scoped=true"
import script from "./expandTicket.vue?vue&type=script&lang=js"
export * from "./expandTicket.vue?vue&type=script&lang=js"
import style0 from "./expandTicket.vue?vue&type=style&index=0&id=a38279c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38279c6",
  null
  
)

export default component.exports